// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__18Bke","title":"Images45_title__36zFc","images":"Images45_images__GnJYL"};